<template>
  <div class="verification-form">
    <div class="verification-form-header">
      <div class="verification-form-header__logo">
        <img :src="SynergyLogo" />
      </div>
      <div>
        <button v-if="skipButton && !loader" class="skip-button" @click="onSkipButtonClick">
          <div class="skip-button__label">{{ $t('skipButtonTitle') }}</div>
          <div class="skip-button__icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10 16L14 12L10 8"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </button>
      </div>
    </div>
    <div v-if="loader" class="verification-preloader">
      <SPreloader :side="90"></SPreloader>
    </div>
    <div v-else class="verification-form__wrapper">
      <div class="verification-form-body">
        <div class="verification-form-body__label">
          <slot name="title"></slot>
        </div>
        <div class="verification-form-description">
          <slot name="description"></slot>
        </div>
      </div>
      <div v-if="$slots.input" class="verification-form-input">
        <slot name="input"></slot>
      </div>
      <div class="verification-form-actions">
        <slot name="actions"></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { SPreloader } from '@synergy/ui-kit-vue3'

// Assets
import SynergyLogo from '@/assets/images/logo.svg'
import { toRefs } from 'vue'

const emit = defineEmits(['skip-click'])

function onSkipButtonClick() {
  emit('skip-click')
}

const props = defineProps({
  skipButton: {
    type: Boolean,
    deafult: true,
  },
  loader: {
    type: Boolean,
    default: false,
  },
})

const { skipButton } = toRefs(props)
</script>

<style scoped lang="scss">
.verification-form {
  display: flex;
  flex-direction: column;
  gap: 36px;
  max-width: 540px;
  width: 100%;
  border-radius: 4px;
  padding: 40px;
  overflow: hidden;
  box-sizing: border-box;

  box-shadow: 0px 6px 18px 0px #00000017;

  &__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 36px;
  }

  @media screen and (max-width: 743px) {
    height: 100%;
    max-width: 100%;
    padding: 24px 16px;

    &__wrapper {
      height: 100%;
      gap: 24px;
    }
  }
}

.verification-form-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__logo {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: auto;
    height: 48px;
  }
}

.verification-form-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;

  &__label {
    font-weight: 500;
    font-size: 28px;
    line-height: 36px;
    letter-spacing: 0%;
    text-align: center;
  }
}

.verification-form-input {
  width: 100%;
}

.verification-form-description {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0%;
  text-align: center;

  &__phone-number {
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0%;
    text-align: center;
  }
}

.verification-form-actions {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: 16px;

  &__timer {
    white-space: nowrap;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0%;
    text-align: center;
    vertical-align: middle;
    color: var(--color-text-secondary);
  }
}

.verification-preloader {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 246px;
}

.skip-button {
  display: flex;
  background-color: transparent;
  padding: 0;
  margin: 0;
  border: none;
  color: #ed131c;
  cursor: pointer;

  &__label {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-weight: 500;
    font-size: 18px;
    line-height: 18px;
    letter-spacing: 0%;
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
  }
}

.invalid {
  // border-color: var(--color-text-accent) !important;
  &--element-border {
    border-radius: 4px;
    border: 1px var(--color-text-accent) solid !important;
  }

  &--text {
    color: var(--color-icon-accent-dangerous) !important;
  }

  &--card-border {
    border-color: var(--color-icon-accent-dangerous) !important;
  }
}
</style>
